import React, { useRef, useEffect, useContext, useState } from "react";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { isInRange } from "../../../utils/dataFunctions";
import { config } from "./config";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";

export const FilterList = ({ field, search, radio }) => {
  const [refresh, setRefresh] = useState(0);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { filter, filterDefaults } = lstore;
  const focusref = useRef(null);
  const listref = useRef({});

  const [listfilter, setListfilter] = useState("");
  const [filterArray, setfilterArray] = useState();

  if (refresh) {
    //do nothing, this is so no errors occur when building in GIT
  }

  useEffect(() => {
    setfilterArray(
      [...filterDefaults[field]].map((item, i) => {
        return { name: item, index: i };
      })
    );

    setListfilter("");
    refs.layoutRefs.current.filterCursor[field] = undefined;
    refs.layoutRefs.current.filterStart[field] = undefined;
  }, [field, filterDefaults, refs.layoutRefs]);

  const onClick = (i) => {
    if (
      isInRange(
        i,
        refs.layoutRefs.current.filterStart[field],
        refs.layoutRefs.current.filterCursor[field]
      )
    ) {
      //do nothing
    } else {
      refs.layoutRefs.current.filterCursor[field] = undefined;
      refs.layoutRefs.current.filterStart[field] = undefined;
      setRefresh(Math.random());
    }
  };

  const changefilter = (val, i) => {
    if (val.name === "All") {
      let newval = filter[field];
      let index = filter[field].indexOf(val.name);
      if (index === -1) {
        //add everything to list
        newval = filterArray.map((item) => {
          return item.name;
        });
      } else {
        //remove from list
        newval = [];
      }
      const newFilter = { ...filter, [field]: newval };
      ldispatch({ type: lactionTypes.SET_FILTER, payload: newFilter });
    } else {
      const numberSelected = Math.abs(
        refs.layoutRefs.current.filterStart[field] -
          refs.layoutRefs.current.filterCursor[field]
      );
      if (numberSelected > 0 && !radio) {
        let newval = filter[field];
        filterArray
          .filter((item, i) => {
            return isInRange(
              i,
              refs.layoutRefs.current.filterStart[field],
              refs.layoutRefs.current.filterCursor[field]
            );
          })
          .forEach((item) => {
            const val = {
              name: item.name,
              index: item.index,
            };
            let index = filter[field].indexOf(val.name);
            if (index === -1) {
              //add to list
              newval.push(val.name);
            } else {
              //remove from list
              newval.splice(index, 1);
              let indexAll = filter[field].indexOf("All");
              if (indexAll !== -1) {
                newval.splice(indexAll, 1);
              }
            }
          });
        const newFilter = { ...filter, [field]: newval };
        refs.layoutRefs.current.filterCursor[field] = undefined;
        refs.layoutRefs.current.filterStart[field] = undefined;
        ldispatch({ type: lactionTypes.SET_FILTER, payload: newFilter });
      } else {
        let newval = filter[field];
        let index = filter[field].indexOf(val.name);
        if (radio) {
          newval = [val.name];
        } else {
          if (index === -1) {
            //add to list
            newval.push(val.name);
          } else {
            //remove from list
            newval.splice(index, 1);
            let indexAll = filter[field].indexOf("All");
            if (indexAll !== -1) {
              newval.splice(indexAll, 1);
            }
          }
        }
        const newFilter = { ...filter, [field]: newval };
        refs.layoutRefs.current.filterCursor = {
          ...refs.layoutRefs.current.filterCursor,
          [field]: val.index,
        };
        refs.layoutRefs.current.filterStart = {
          ...refs.layoutRefs.current.filterStart,
          [field]: val.index,
        };
        ldispatch({ type: lactionTypes.SET_FILTER, payload: newFilter });
      }
    }
  };

  const onMouseEnter = (e, item, i) => {
    focusref.current.focus();
    if (field in refs.layoutRefs.current.filterCursor) {
      const numberSelected = Math.abs(
        refs.layoutRefs.current.filterStart[field] -
          refs.layoutRefs.current.filterCursor[field]
      );
      if (!numberSelected) {
        refs.layoutRefs.current.filterCursor = {
          ...refs.layoutRefs.current.filterCursor,
          [field]: i,
        };
        refs.layoutRefs.current.filterStart = {
          ...refs.layoutRefs.current.filterStart,
          [field]: i,
        };
      }
    } else {
      refs.layoutRefs.current.filterCursor = {
        ...refs.layoutRefs.current.filterCursor,
        [field]: i,
      };
      refs.layoutRefs.current.filterStart = {
        ...refs.layoutRefs.current.filterStart,
        [field]: i,
      };
    }
    setRefresh(Math.random());
  };
  const onKeyDown = (e) => {
    const lastPosition = refs.layoutRefs.current.filterCursor[field];
    const downPosition = lastPosition + 1;
    const upPosition = lastPosition - 1;
    if (e.key === "ArrowDown") {
      refs.layoutRefs.current.filterCursor = {
        ...refs.layoutRefs.current.filterCursor,
        [field]: downPosition,
      };
      if (downPosition in listref) {
        if (listref[downPosition].current) {
          listref[downPosition].current.scrollIntoView({
            block: "end",
          });
        }
      }
    }
    if (e.key === "ArrowUp") {
      refs.layoutRefs.current.filterCursor = {
        ...refs.layoutRefs.current.filterCursor,
        [field]: upPosition,
      };
      if (upPosition in listref) {
        if (listref[upPosition].current) {
          listref[upPosition].current.scrollIntoView({
            block: "start",
          });
        }
      }
    }
    setRefresh(Math.random());
  };

  const searchstyle = {
    height: 20,
    width: refs.componentSize.current[field].width,
  };
  const filterBySearch = (e) => {
    setListfilter(e.target.value);

    setfilterArray(
      [...filterDefaults[field]]
        .map((item, i) => {
          return { name: item, index: i };
        })
        .filter((fitem) => {
          return (
            fitem.name
              .toString()
              .toLowerCase()
              .indexOf(e.target.value.toLowerCase()) !== -1
          );
        })
    );
  };

  return "filterCursor" in refs.layoutRefs.current && filterArray ? (
    <div
      className="filterblock"
      style={{
        height: refs.componentSize.current[field].height,
        width: refs.componentSize.current[field].width,
        margin: 0,
        display: "block",
        overflow: "hidden",
      }}
    >
      {search && (
        <div>
          <input
            style={searchstyle}
            value={listfilter}
            placeholder="Search..."
            onChange={filterBySearch}
          />
        </div>
      )}
      <div
        style={{
          height: refs.componentSize.current[field].height - (search ? 24 : 0),
          width: refs.componentSize.current[field].width,
          margin: 0,
          display: "block",
          justifyContent: "space-around",
          overflow: "auto",
        }}
      >
        <div
          ref={focusref}
          tabIndex={0}
          onKeyDown={(e) => onKeyDown(e)}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {filterArray.map((item, i) => {
            const val = {
              name: item.name,
              index: item.index,
            };
            listref[i] = { current: null };

            return (
              <div
                className="filter-list-parent"
                key={i}
                ref={listref[i]}
                onMouseEnter={(e) => onMouseEnter(e, item, i)}
                style={{
                  backgroundColor: radio
                    ? undefined
                    : isInRange(
                        i,
                        refs.layoutRefs.current.filterCursor[field],
                        refs.layoutRefs.current.filterStart[field]
                      )
                    ? config.scrollColour
                    : undefined,
                }}
              >
                <div style={{ display: "flex" }} onClick={() => onClick(i)}>
                  <input
                    checked={filter[field].indexOf(val.name) !== -1}
                    type={radio ? "radio" : "checkbox"}
                    value={item.name}
                    name={field}
                    onChange={() => changefilter(val, i)}
                  />
                  <span
                    title={item.name}
                    style={{
                      fontSize: config.fontSize,
                      display: "block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.name}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : null;
};
